/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function () {
  var LIMITED_PRODUCT_ID = 10195785875778;
  var isNormalizingCart = false;

  function getCart() {
    return fetch(window.routes.cartUrl + '.js', {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('cart_read_failed');
      }

      return response.json();
    });
  }

  function getLimitedItems(cart) {
    return cart.items.filter(function (item) {
      return Number(item.product_id) === LIMITED_PRODUCT_ID;
    });
  }

  function normalizeLimitedProduct(cart) {
    var limitedItems = getLimitedItems(cart);
    var updates = {};

    limitedItems.forEach(function (item, index) {
      var allowedQuantity = index === 0 ? 1 : 0;

      if (item.quantity !== allowedQuantity) {
        updates[item.key] = allowedQuantity;
      }
    });

    if (Object.keys(updates).length === 0) {
      return Promise.resolve(cart);
    }

    return fetch(window.routes.cartUrl + '/update.js', {
      body: JSON.stringify({ updates: updates }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('cart_limit_update_failed');
      }

      return response.json();
    });
  }

  function enforceLimitedProduct() {
    if (isNormalizingCart) {
      return Promise.resolve(null);
    }

    isNormalizingCart = true;

    return getCart().then(normalizeLimitedProduct).then(function (cart) {
      isNormalizingCart = false;

      if (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }

      return cart;
    }).catch(function () {
      isNormalizingCart = false;
      return null;
    });
  }

  function isLimitedProductForm(form) {
    var section = form ? form.closest('[data-limit-one-per-order]') : null;

    return section && section.getAttribute('data-limit-one-per-order') === 'true';
  }

  function showLimitMessage(button, message) {
    var oldMessage = button.parentNode.querySelector('.ProductForm__Error');

    if (oldMessage) {
      oldMessage.remove();
    }

    var errorMessage = document.createElement('span');
    errorMessage.className = 'ProductForm__Error Alert Alert--error';
    errorMessage.textContent = message;
    button.insertAdjacentElement('afterend', errorMessage);

    setTimeout(function () {
      errorMessage.remove();
    }, 3000);
  }

  function addLimitedProduct(event, button, form) {
    if (form.getAttribute('data-limit-one-busy') === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    form.setAttribute('data-limit-one-busy', 'true');
    button.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    getCart().then(function (cart) {
      if (getLimitedItems(cart).length > 0) {
        return normalizeLimitedProduct(cart).then(function () {
          throw new Error('limit_one_reached');
        });
      }

      var formData = new FormData(form);
      formData.set('quantity', '1');

      return fetch(window.routes.cartAddUrl + '.js', {
        body: formData,
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (response) {
        if (!response.ok) {
          return response.json().then(function (content) {
            throw new Error(content.description || 'Unable to add this item.');
          });
        }

        return response.json();
      });
    }).then(function (item) {
      form.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: item,
          quantity: 1
        }
      }));
    }).catch(function (error) {
      if (error.message === 'limit_one_reached') {
        showLimitMessage(button, 'LIMIT 1 PER CUSTOMER');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      } else {
        showLimitMessage(button, error.message || 'Unable to add this item.');
      }
    }).then(function () {
      form.removeAttribute('data-limit-one-busy');
      button.removeAttribute('disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-action="add-to-cart"]');
    var form = button ? button.closest('form[action*="/cart/add"]') : null;

    if (!button || !isLimitedProductForm(form)) {
      return;
    }

    addLimitedProduct(event, button, form);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var button;

    if (!isLimitedProductForm(form)) {
      return;
    }

    button = form.querySelector('[data-action="add-to-cart"]');

    if (button) {
      addLimitedProduct(event, button, form);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceLimitedProduct);
  } else {
    enforceLimitedProduct();
  }
})();

(function () {
  var modal = null;
  var lastTrigger = null;

  function ensureModal() {
    if (modal) {
      return modal;
    }

    modal = document.createElement('div');
    modal.id = 'not-for-sale-modal';
    modal.className = 'NotForSaleModal';
    modal.setAttribute('aria-hidden', 'true');

    modal.innerHTML = [
      '<div class="NotForSaleModal__Overlay" data-not-for-sale-close></div>',
      '<div class="NotForSaleModal__Dialog" role="dialog" aria-modal="true" aria-labelledby="NotForSaleModalTitle">',
      '  <button type="button" class="NotForSaleModal__Close" data-not-for-sale-close aria-label="Close">&times;</button>',
      '  <p id="NotForSaleModalTitle" class="NotForSaleModal__Title Heading u-h3">NOT FOR SALE</p>',
      '  <p class="NotForSaleModal__Text">This friends and family item is not for sale.</p>',
      '  <button type="button" class="Button Button--primary NotForSaleModal__Button" data-not-for-sale-close>Close</button>',
      '</div>'
    ].join('');

    document.body.appendChild(modal);

    return modal;
  }

  function openModal(trigger) {
    var instance = ensureModal();
    lastTrigger = trigger || null;

    instance.setAttribute('aria-hidden', 'false');
    document.body.classList.add('NotForSaleModal--open');

    var closeButton = instance.querySelector('.NotForSaleModal__Button');

    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeModal() {
    if (!modal) {
      return;
    }

    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('NotForSaleModal--open');

    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-not-for-sale-trigger]');

    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    var closeTarget = event.target.closest('[data-not-for-sale-close]');

    if (closeTarget) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    var trigger = event.target.closest('[data-not-for-sale-trigger]');

    if (trigger && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    if (event.key === 'Escape' && modal && modal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });
})();
